import { IMainInitialState } from '@hts/shared/types';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: IMainInitialState = {
  currentUser: false,
  headerPopupActive: false,
  isCustomMode: false,
  activeCategory: null,
  activeSubcategory: null,
  draftCard: null,
  categories: [],
  videoEnabled: false,
  faqEnabled: true,
  allCategories: [],
};

const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    loginUser: (state, { payload }: PayloadAction<object>) => {
      state.currentUser = payload;
    },
    logoutUser: (state) => {
      localStorage.removeItem('token');

      state.currentUser = false;
    },
    activeHeaderPopup: (state) => {
      state.headerPopupActive = true;
    },
    disableHeaderPopup: (state) => {
      state.headerPopupActive = false;
    },
    toggleHeaderPopup: (state) => {
      state.headerPopupActive = !state.headerPopupActive;
    },
    setCustomMode: (state) => {
      state.isCustomMode = true;
    },
    unsetCustomMode: (state) => {
      state.isCustomMode = false;
    },
    setActiveCategory: (state, { payload }) => {
      state.activeCategory = payload;
    },
    unsetActiveCategory: (state) => {
      state.activeCategory = null;
    },
    setActiveSubcategory: (state, { payload }) => {
      state.activeSubcategory = payload;
    },
    unsetActiveSubcategory: (state) => {
      state.activeSubcategory = null;
    },
    setDraftCard: (state, { payload }) => {
      state.draftCard = payload;
    },
    unsetDraftCard: (state) => {
      state.draftCard = null;
    },
    setCategories: (state, { payload }) => {
      state.categories = payload;
    },
    setAllCategories: (state, { payload }) => {
      state.allCategories = payload;
    },
    setVideoAvailability: (state, { payload }) => {
      state.videoEnabled = payload;
    },
    setFaqAvailability: (state, { payload }) => {
      state.faqEnabled = payload;
    },
  },
});

export const { reducer: mainReducer, actions: mainActions } = mainSlice;
